<template>
  <div class="record-box">
    <div>
      <div>
        <span>CopyRight © 2021 广西贺州黄姚古镇投资有限公司 版权所有</span>
        <a href="https://beian.miit.gov.cn/" target="_blank">
          <span style="margin-left:10px;font-size:13px;">桂ICP备19009669号</span>
        </a>
        <br class="br-on" />
        <span style="margin-right:0px;">咨询</span>：
        <span style="margin-left:0px;">0774-6722748</span>
        <span style="margin-right:0px;">投诉</span>：
        <span style="margin-left:0px;">0774-6728078</span>
        <span style="margin-right:0px;">救援</span>：
        <span style="margin-left:0px;">0774-6722173</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer"
}
</script>
<style scoped lang="scss">
.record-box {
  width: 100%;
  height: 100px;
  padding: 0 80px;
  box-sizing: border-box;
  background-color: #fff;
  margin-top: 20px;

  div {
    max-width: 1400px;
    height: 100px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    line-height: 1.5;

    span {
      margin: 0 10px;
    }
  }
}
</style>
